<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div>
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>
          <span class="mdi mdi-information-outline title-icon"></span>
          {{'assign.details.title' | translate}}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
          <div class="details-wrapper">
            <div class="details-data">
                <div>
                    <ul>
                        <li style="display: flex;">
                            <span class="title" id="serials">{{'assign.fde.license-details-workstation-id' | translate}}</span>
                            <span class="scrollable">{{serials}}</span>
                        </li>
                        <li>
                            <span class="title" id="licenses">{{'assign.details.licenses_consumed' | translate}}</span><span>{{licensesConsumed}}</span>
                        </li>
                        <li>
                            <span class="title">{{'MAINT_EXPIRES' | translate}}</span><span>{{ data['maintenanceEnd'] * 1000 | date }}</span>
                        </li>
                        <li>
                            <span class="title">{{'EXPIRES' | translate}}</span>
                            @if (data['expiration']) {
                                <span>{{ data['expiration'] * 1000 | date }}</span>
                            } @else {
                                <span>{{ 'D3ED_NEVER' | translate }}</span>
                            }
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div mat-dialog-actions>
        <button mat-raised-button type="button" color="primary" (click)="onCloseClick()">{{'CLOSE' | translate}}</button>
    </div>
</div>
